import MasterCrudPage from '../../components/MasterCrudPage';

export default function Religions() {
  return (
    <MasterCrudPage
      config={{ title: 'Religion', apiBase: '/payroll/masters/religions', listKey: 'religions', entityKey: 'religion', fields: [], bare: true }}
    />
  );
}
